import script from "./TooltipHelper.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipHelper.vue?vue&type=script&setup=true&lang=js"

import "./TooltipHelper.vue?vue&type=style&index=0&id=167b65c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167b65c1"]])

export default __exports__